export default __webpack_public_path__ + "static/media/codingvid.fec91060.mp4";